import DashedDividerProps from "./DashedDivider.types";
import "./DashedDivider.scss";

function DashedDivider(props: DashedDividerProps) {
  const { direction = "horizontal", ...options } = props;

  return <div className={`dashed-divider--${direction}`} {...options} />;
}

export default DashedDivider;
